<template>
  <div class="w-full">
    <a-spin :spinning="spinning">
      <div v-if="bidderInfo.project" class="m-auto text-base" :style="{ width: '750px' }">
        <div
          class="w-full px-4 my-4 text-xl text-left border-4 border-t-0 border-b-0 border-r-0 border-blue-400 border-solid text-bold"
          :style="{ width: '750px' }"
        >
          项目信息
        </div>
        <div class="w-full py-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            项目名称:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ bidderInfo.project }}
          </div>
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            招标人:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ bidderInfo.proprietor }}
          </div>
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            担保额度:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ bidderInfo.money ? bidderInfo.money.toFixed(2) : '' }}
            <span class="text-red-500">
              {{ convertCurrency(parseFloat(bidderInfo.money ? bidderInfo.money.toFixed(2) : '')) }}
            </span>
          </div>
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            担保费:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ bidderInfo.poundage ? bidderInfo.poundage.toFixed(2) : '' }}
            <span class="text-red-500">
              {{
                convertCurrency(
                  parseFloat(bidderInfo.poundage ? bidderInfo.poundage.toFixed(2) : ''),
                )
              }}
            </span>
          </div>
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            保证金截止时间:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ bidderInfo.kbdate }}
          </div>
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left leading-8 text-right text-gray-400" :style="{ width: '200px' }">
            推荐码:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            <a-input v-model="r_code" placeholder="(选填)" style="width: 200px" />
          </div>
        </div>
        <div
          class="w-full px-4 my-4 text-xl text-left border-4 border-t-0 border-b-0 border-r-0 border-blue-400 border-solid text-bold"
          :style="{ width: '750px' }"
        >
          企业信息
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            投标企业名称:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ bidderInfo.bidder }}
          </div>
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            统一社会信用代码:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ bidderInfo.taxNumber }}
          </div>
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left leading-8 text-right text-gray-400" :style="{ width: '200px' }">
            <span class="leading-8 text-red-500">*</span>
            联系人:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            <a-select
              style="width: 200px"
              placeholder="请选择联系人"
              v-model="contact_id"
              @select="contactselect"
            >
              <a-select-option v-for="(item, index) in contact" :key="index" :value="item.id">{{
                item.name
              }}</a-select-option>
            </a-select>
            <a-button type="primary" class="ml-6" @click="contactFlag = true">管理</a-button>
          </div>
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            营业地址:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ selectcontact.address }}
          </div>
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            联系人号码:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ selectcontact.phone_number }}
          </div>
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }"> 邮箱: </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ selectcontact.email }}
          </div>
        </div>
        <div class="overflow-hidden text-sm" :style="{ width: '750px' }">
          <div class="float-left h-2" :style="{ width: '200px' }"></div>
          <div class="float-left">
            <a-checkbox v-model="agreement">您已阅读并同意</a-checkbox>
            <span class="text-red-500 cursor-pointer" @click="agreementFlag = true"
              >《电子保函申请书》</span
            >
          </div>
        </div>
        <div class="justify-center w-full py-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left h-2" :style="{ width: '200px' }"></div>
          <a-button class="float-left" type="primary" @click="doContract" :disabled="!agreement">
            提交申请
          </a-button>
        </div>
      </div>
    </a-spin>
    <a-modal
      :visible="agreementFlag"
      title="《电子保函申请书》"
      :width="595"
      :footer="null"
      :bodyStyle="{ padding: 0 }"
      @cancel="agreementFlag = false"
    >
      <div
        v-html="agreementText"
        style="padding: 30px 57px; height: calc(100vh - 300px); overflow-y: scroll"
      ></div>
    </a-modal>
    <Contact
      ggb="lishui"
      :taxNumber="bidderInfo.taxNumber"
      :visible="contactFlag"
      @cancel="() => (contactFlag = false)"
      @refresh="getContacts(false)"
      @select="contactSelect"
    ></Contact>
    <ContactForm
      ggb="lishui"
      :taxNumber="bidderInfo.taxNumber"
      :visible="contactFormFlag"
      @cancel="() => (contactFormFlag = false)"
      @ok="getContacts(false)"
    ></ContactForm>
  </div>
</template>

<script>
  import { GgbTemp, SaveContract } from '@/api/ggb/linhai';
  import { contacts, last_contact } from '@/api/contact';
  import { convertCurrency, transContentLinHai } from '@/utils/transContent';
  import Contact from '@/views/ggb/common/contact/index.vue';
  import ContactForm from '@/views/ggb/common/contact/form.vue';
  import bus from '@/utils/bus';
  export default {
    components: {
      Contact,
      ContactForm,
    },
    props: {
      reopen: Number,
      bidderInfo: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        agreement: false,
        spinning: false,
        tempInfo: {},
        agreementFlag: false,
        r_code: '',
        contact: [],
        contactFlag: false,
        contactFormFlag: false,
        contact_id: undefined,
        selectcontact: {},
        info: {},
      };
    },
    async mounted() {
      this.tempInfo = await GgbTemp('lishui');
    // this.r_code = this.bidderInfo.projects.user_id;
      // if (this.$route.query.code) {
      //   this.r_code = this.$route.query.code;
      // }
    },
    computed: {
      agreementText() {
        return this.tempInfo.agreement
          ? transContentLinHai(this.tempInfo.agreement, this.bidderInfo)
          : '';
      },
    },
    watch: {
      'bidderInfo.taxNumber'(a) {
        if (a) {
          this.getContacts(true);
        }
      },
    },
    methods: {
      async getContacts(isfirst) {
        this.contact =
          (
            await contacts({
              current: -1,
              qp: JSON.stringify({ eq: { taxNumber: this.bidderInfo.taxNumber } }),
            })
          ).data || [];
        if (isfirst) {
          if (this.contact.length == 0) {
            this.contactFormFlag = true;
          } else if (this.contact.length == 1) {
            this.contact_id = this.contact[0].id;
            this.selectcontact = this.contact[0];
          } else {
            let contract = await last_contact({
              ggb: 'lishui',
              taxNumber: this.bidderInfo.taxNumber,
            });
            if (contract && contract.contact_id) {
              this.contact_id = contract.contact_id;
              this.selectcontact =
                this.contact.find((e) => {
                  return e.id == contract.contact_id;
                }) || {};
            }
          }
        }
      },
      convertCurrency,
      contactSelect(record) {
        this.contact_id = record.id;
        this.selectcontact = record;
      },
      contactselect(id) {
        this.contact_id = id;
        this.selectcontact =
          this.contact.find((e) => {
            return e.id == id;
          }) || {};
      },
      async doContract() {
        if (!this.contact_id) {
          this.$message.error('请选择联系人');
          return;
        }
        // if (!this.selectcontact.address) {
        //   this.$message.error('请填写营业地址');
        //   return;
        // }
        try {
          this.spinning = true;
          this.info = await SaveContract(
            Object.assign(this.bidderInfo, {
              r_code: this.r_code,
              contact_id: this.contact_id,
            }),
          );
          bus.$emit('tosetp2', this.info);
          this.$emit('next');
        } catch (error) {
          this.$message.error(error);
        } finally {
          this.spinning = false;
        }
      },
    },
  };
</script>
